import React from 'react'
import PropTypes from 'prop-types'
import styles from './ApplicationViewPort.module.scss'
import { AppCard } from '../AppCard'

export function ApplicationViewPortMobile({
  applications, noAppsMsg, errorContactMsg, onClick, buttonLinkText, isGridView
}) {
  const gridClass = styles['mobile-application-grid']
  const noAppsMessageClass = styles['mobile-no-applications-message']
  const errorContactMessageClass = styles['mobile-error-contact-message']

  return (
    <div className={gridClass}>
      {applications.length ? (
        applications.map((app) => (
          <AppCard
            key={app.appId}
            name={app.label}
            imageUrl={app.src}
            onOpenButtonClick={() => onClick(app.link)}
            buttonLinkText={buttonLinkText}
            onFavoriteClick={() => onClick()}
            isGridView={isGridView}
          />
        ))
      ) : (
        <div>
          <div className={noAppsMessageClass}> {noAppsMsg} </div>
          <div className={errorContactMessageClass}> {errorContactMsg} </div>
        </div>
      )}
    </div>
  )
}

ApplicationViewPortMobile.propTypes = {
  applications: PropTypes.arrayOf(PropTypes.shape({
    appId: PropTypes.string,
    src: PropTypes.string,
    link: PropTypes.string,
    label: PropTypes.string.isRequired,
  })),
  noAppsMsg: PropTypes.string,
  errorContactMsg: PropTypes.string,
  onClick: PropTypes.func,
  buttonLinkText: PropTypes.string,
  isGridView: PropTypes.bool,
}

ApplicationViewPortMobile.defaultProps = {
  applications: [],
  noAppsMsg: 'NoAppsMsg',
  errorContactMsg: 'ErrorContactMsg',
  onClick: () => {},
  buttonLinkText: '',
  isGridView: true,
}
